<template>
  <div class="aside-order-help-component">
    <div class="flex align-center">
      <font-awesome-icon icon="headset" />
      <span v-if="currentStep === 0" class="help-text">
        <span class="d-block font-weight-medium">
          Здравствуйте
          <template v-if="getClientName">, {{ getClientName }}</template>
          !
        </span>
        Служба доставки {{ companyName }}, меня зовут {{ userName }}. Давайте проверим Ваш заказ!
      </span>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'OrderHelp',
    props: {
      text: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        userName: '',
      }
    },
    computed: {
      ...mapState({
        basket: state => state.baskets.basket,
        currentStep: state => state.newOrder.currentStep,
        companyName: state => state.app.companyName,
      }),
      getClientName () {
        return this.basket.client ? this.basket.client.name : ''
      },
    },
    mounted () {
      const userData = JSON.parse(localStorage.getItem('user'))
      this.userName = userData.data.name
    },
  }
</script>

<style lang="less" scoped>
.aside-order-help-component {
  position: relative;
  margin-top: 25px;
  margin-bottom: 30px;
  background-color: #fff3d6;
  border-radius: 10px;
  padding: 21px 12px 13px;
  z-index: 0;
  &:after {
    content: '';
    position: absolute;
    left: 5px;
    top: -10px;
    border: 12px solid;
    border-color: transparent #fff3d6 transparent transparent;
  }
  svg {
    width: 25px;
    height: 25px;
    margin-right: 21px;
    font-size: 16px;
    line-height: 19px;
    .fill-svg(#E1CD9D);
  }
}
</style>
